import React, { useEffect, useState } from "react";
import TestimonialCard from "../common/cards/TestimonialCard";
import TestimonialData from "../../utils/Testimonials.json";
import { AnimatePresence, motion } from "framer-motion";

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!TestimonialData || TestimonialData.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === TestimonialData.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const slideVariants = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
  };

  return (
    <div className="flex py-10 flex-col justify-center items-center">
      <h2 className="md:text-2xl text-xl font-semibold text-center mb-10">
        Our Happy Students
      </h2>
      <div className="flex flex-col lg:flex-row w-full">
        <div className="lg:w-1/2 w-full flex flex-col justify-center items-center px-10 border-r border-gray-200">
          <h2 className="text-xl font-medium text-black leading-tight mb-4">
            Your Story Could Be Next!
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            We love hearing from our students. Share your experience and inspire
            others!
          </p>
          <button className="bg-white px-10 text-black py-3 text-sm border border-gray-400 rounded-full group">
            Join Us
          </button>
        </div>
        <div className="relative flex justify-end items-center w-full lg:w-1/2 h-[60vh] overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              variants={slideVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ duration: 0.8 }}
              className="absolute lg:py-20 lg:mr-20 mx-5"
            >
              <TestimonialCard testimonial={TestimonialData[currentIndex]} />
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
